export default import.meta.ROLLDOWN_FILE_URL_XkoF7BSSbncKX_yOJhf3Ow